import React from 'react';
import { useNavigate } from 'react-router-dom';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import Card from 'react-bootstrap/Card';
import Button from '../Button/Button';
import './carousel.css';
import carouselPic10 from '../../assets/carousel-pic10.png';
import carouselPic11 from '../../assets/carousel-pic-11.png';
import carouselPic12 from '../../assets/carousel-pic-12.png';
import topImage from '../../assets/top-image.png';

const MyCarousel = () => {
  const navigate = useNavigate();

  const handleReadMore = (id) => {
    navigate(`/blog/${id}`);
  };

  const ourprograms = [
    {
      id: "skills-gap",
      image: carouselPic11,
      title: 'Industry 4.0 revolution and skill Gap',
      description: 'This is the age of the 4th Industrial revolution. This means industrial processes are upgraded to work at a much faster pace. Tasks are being automated and much of the data is digitized. The world is going through a tremendous change that will completely change the way things work in industries within a few years',
      btn: 'Read More'
    },
    {
      id: "industrial-automation",
      image: carouselPic10,
      title: 'Augmented Reality on Industrial Machine',
      description: 'Augmented Reality enhances an existing physical environment ...',
      btn: 'Read More'
    },
    {
      id: "fourth-industrial-revolution",
      image: carouselPic12,
      title: 'Virtual reality, Augmented reality, Mixed reality',
      description: 'Technological advancements over the years have powered the different stages of the industrial revolution. The 1st industrial revolution saw the usage of steam power that increased productivity and the 2nd industrial revolution employed electricity for faster production at lower cost',
      btn: 'Read More'
    },
    {
      id: "analytical-proficiency",
      image: topImage,
      title: 'Being fluent in the "language of data"',
      description: 'The role of data in business and societal transformation, especially across the industrial revolutions.',
      btn: 'Read More'
    },
  ];

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 1
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1
    }
  };

  return (
    <div className='my-own-custom-container'>
      <div data-aos='fade-up'>
        <h1 className='main-carousel-heading fs-xl-heading'>
          Blogs<span className='carousel-heading-span'>!</span>
        </h1>
      </div>
      <div className='container-fluid'>
        <Carousel
          swipeable={true}
          draggable={true}
          responsive={responsive}
          ssr={true}
          infinite={true}
          autoPlay={false}
          autoPlaySpeed={5000}
          keyBoardControl={true}
          customTransition='all .5'
          transitionDuration={500}
          containerClass='carousel-container'
          itemClass='carousel-item-padding-10-px'
          showDots={false}
          arrows={true}
        >
          {ourprograms.map((item) => (
            <div
              key={item.id}
              className="card-bg-remove"
              onClick={() => handleReadMore(item.id)}
            >
              <Card className="rounded-img">
                <div className="card-img-wrapper">
                  <Card.Img
                    variant="top"
                    src={item.image}
                    className="card-img"
                  />
                </div>
                <Card.Body className="card-body-flex">
                  <h5 className="fs-xl-para card-title">
                    {item.title}
                  </h5>
                  <p className="truncated-text card-description">
                    {item.description}
                  </p>
                  <div className="card-button-wrapper">
                    <Button
                      text={item.btn}
                      size="discord"
                      onClick={() => handleReadMore(item.id)}
                    />
                  </div>
                </Card.Body>
              </Card>
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  );
};

export default MyCarousel;
